import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSankeyChart: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSankeyChart"><Path d="M3.5 5.5C10.6613 5.5 13.3387 14.5 20.5 14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 10.5C10.0698 10.5 13.9302 18.5 20.5 18.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 5.5C12.739 5.5 11.8482 18.5 3.5 18.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSankeyChart;
